module.exports = __webpack_public_path__ + "media/npc_dota_hero_tidehunter.5eed8864.webm";